import { LeadStatus } from '../../types';

export const LEAD_STATUSES: LeadStatus[] = [
  'new',
  'contacted',
  'qualified',
  'nurture',
  'lost',
  'out-of-scope',
];

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  new: 'New',
  contacted: 'Contacted',
  qualified: 'Qualified',
  nurture: 'Nurture',
  lost: 'Lost',
  'out-of-scope': 'Out of scope',
};

/** Closed / non-pipeline statuses hidden from the default “All Leads” list. */
export const LEAD_STATUSES_EXCLUDED_FROM_ALL: LeadStatus[] = ['lost', 'out-of-scope'];

export function leadStatusClassName(status: LeadStatus): string {
  return `status-${status}`;
}
